import { encoder, decoder } from '../lib/buffer_utils.js';
export var encodeBase64 = function encodeBase64(input) {
  var unencoded = input;
  if (typeof unencoded === 'string') {
    unencoded = encoder.encode(unencoded);
  }
  var CHUNK_SIZE = 0x8000;
  var arr = [];
  for (var i = 0; i < unencoded.length; i += CHUNK_SIZE) {
    arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
  }
  return btoa(arr.join(''));
};
export var encode = function encode(input) {
  return encodeBase64(input).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};
export var decodeBase64 = function decodeBase64(encoded) {
  var binary = atob(encoded);
  var bytes = new Uint8Array(binary.length);
  for (var i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};
export var decode = function decode(input) {
  var encoded = input;
  if (encoded instanceof Uint8Array) {
    encoded = decoder.decode(encoded);
  }
  encoded = encoded.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
  try {
    return decodeBase64(encoded);
  } catch (_unused) {
    throw new TypeError('The input to be decoded is not correctly encoded.');
  }
};